import { useCallback, useEffect, useState } from 'react';

const useMediaQuery = (
  minWidth: number,
) => {
  // Set the default value to undefined in order to properly distinguish the falsey values
  // where undefined is the value before computing whether the screen size is smaller than the minWidth
  // i.e. a state where we don't really know whether we're below the threshold or not
  // and false is the value where the computation returns false
  const [isSmallerThan, setIsSmallerThan] = useState<boolean>();

  const handler = useCallback(() => {
    const width = window.innerWidth;
    const isDesiredWidth = width < minWidth;
    setIsSmallerThan(isDesiredWidth);
  }, [minWidth]);

  useEffect(() => {
    window.addEventListener('resize', handler);
    handler();

    return () => {
      window.removeEventListener('resize', handler);
    };
  }, [handler]);

  return isSmallerThan;
};

export default useMediaQuery;